import $ from "jquery";
import Storage from "@bd-utils/storage";
import BD_Component from "@bd-core/bd-component";
import compile from "@bd-utils/handlerbars-helper";
import CONFIG from "@bd-core/config";
import { getState } from "@bd-stores/store";
import {
    getFinalTeamAnswers,
    getRoomStatus,
    getTeamAnswers,
} from "@bd-stores/game-progress";
import CompletionPopup from "@bd-utils/completion-popup";
import Incidents from "@bd-utils/incidents";
import Feedbacks from "@bd-utils/feedback";
import Screen from "@bd-utils/screen";
import {
    // getRoomAnswers,
    maybeUpdateRoomStatus,
    saveFinalRoomAnswers,
    updateRoomAnswer,
} from "@bd-core/firebase-actions";
import gsap from "gsap";
import Draggable from "gsap/Draggable";
import GameLogic from "@bd-core/game-logic";
import Recap from "@bd-utils/recap";

export class RoomSingleQuestionSingle extends BD_Component {
    constructor() {
        super();

        this.id = "single_question";
        this.templateID = "single_question-template";

        this.elms = {
            closeQuestion: ".js-multipleQuestions-close",
            openQuestion: ".js-multipleQuestions-open",
            questionPopup: ".js-questions-popup",
            booleanAnswer: ".js-boolean-answer",
            booleanItem: ".js-question",
            answers: ".js-answers",
            checkBtn: ".js-check",
            check: ".js-action",
            count: ".count",
            correct: ".js-correct",
            middle: ".js-middle",
            wrong: ".js-wrong",
            roomStatus: ".js-room-status",
            background: ".js-screen-img",
            backgroundImage: ".screen__navigate",
            closeButtonPopup: ".multipleQuestions__close",
            backButton: ".app__back",
            timer: ".js-timer",
            audioBox: ".js-multipleQuestions-audio",
            questionBox: ".js-multipleQuestions-question",
            ringtone: ".js-ringtone",
            acceptCall: ".js-play-audio",
            callPlayer: ".js-phone",
            challengeAudio: ".js-audio-challenge",
            skipbutton: ".js-skip-audio",
            goToQuestionBtn: ".js-continue-question",
            finishFeedback: ".js-finish-feedback",
            replayAudioBtn: ".js-replay-audio",
            finishRecap: ".js-finish-recap",
        };

        this._events = this.getEvents();

        this.completionPopup = new CompletionPopup();
        this.incident = new Incidents();
        this.feedback = new Feedbacks();
        this.recap = new Recap();

        this.startX = 0;
        this.startY = 0;
        this.zoom = 100;
        this.hotspotSize = 25.5;
        this.isDown = false;
        this.timerWarningDuration = 2000; // milliseconds
        this.timerWarningClass = "timer-warning";
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.openQuestion,
                handler: this.onQuestionToggler,
            },
            {
                event: "click",
                selector: elms.closeQuestion,
                handler: this.onQuestionToggler,
            },
            {
                event: "change",
                selector: elms.booleanAnswer,
                handler: this.onAnswerBoolean,
            },
            {
                event: "click",
                selector: elms.checkBtn,
                handler: this.onCheck,
            },
            {
                event: "wheel",
                selector: elms.background,
                handler: this.onBackgroundScroll,
            },
            {
                event: "click",
                selector: elms.acceptCall,
                handler: this.playChallengeAudio,
            },
            {
                event: "click",
                selector: elms.skipbutton,
                handler: this.skipAudio,
            },
            {
                event: "click",
                selector: elms.goToQuestionBtn,
                handler: this.proceedToQuestion,
            },
            {
                event: "click",
                selector: elms.finishRecap,
                handler: this.finishRecap,
            },
            {
                event: "click",
                selector: elms.finishFeedback,
                handler: this.finishFeedback,
            },
            {
                event: "click",
                selector: elms.replayAudioBtn,
                handler: this.replayAudio,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
        this.listenFInishedAudio();
        window.screenCalculationFunc = () => Screen.calculateCoverSize();
    }

    listenFInishedAudio() {
        const elms = this.elms;
        const challengeEl = this.getMediaElement(elms.challengeAudio);
        challengeEl.addEventListener("ended", () => {
            this.skipAudio();
        });
    }

    getModifiedData() {
        const modified = { ...this._data };

        let _challenge = this._data.challenges;
        const defaultNormalImage = `${CONFIG.themeURL}/assets/images/multiplequestion-item-new.png`;
        const defaultHoverImage = `${CONFIG.themeURL}/assets/images/multiplequestion-item-hover-new.png`;
        const defaultImageBg = `${CONFIG.themeURL}/assets/images/bg-multiple-questions-new.png`;

        const _image_bg = this._data.image_bg
            ? this._data.image_bg
            : defaultImageBg;

        _challenge = {
            normal_image: _challenge?.normal_image
                ? _challenge?.normal_image
                : defaultNormalImage,
            hover_image: _challenge?.hover_image
                ? _challenge?.hover_image
                : defaultHoverImage,
        };

        // const hintHotspots = this._data?.hotspots?.filter(
        //     (h) => h["hotspot_type"] === "hint",
        // );

        // const hotspotCount = hintHotspots?.length ?? 0;
        // const defaultValue = "50%";

        // const _hints = this._data?.hints?.map((hint, i) => {
        //     const font_fam = hint?.hint_font_family?.split("|");
        //     const font_name = font_fam[0];
        //     const font_category = font_fam[1];

        //     return {
        //         ...hint,
        //         font_family: `"${font_name}", ${font_category}`,
        //         has_image: hint?.image,
        //         position_top:
        //             hotspotCount > 0 && hintHotspots[i]
        //                 ? hintHotspots[i].position_top
        //                 : defaultValue,
        //         position_left:
        //             hotspotCount > 0 && hintHotspots[i]
        //                 ? hintHotspots[i].position_left
        //                 : defaultValue,
        //     };
        // });

        let questionHotspots = this._data.hotspots.filter(
            (h) => h.hotspot_type === "question",
        );
        $.each(this._data.questions, function (i, question) {
            if (questionHotspots[i]) {
                question.position_left = questionHotspots[i].position_left;
                question.position_top = questionHotspots[i].position_top;
            }
        });

        const modifiedData = {
            ...modified,
            hints: [],
            challenges: _challenge ?? {},
            image_bg: _image_bg ?? defaultImageBg,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();
        const isForcedOpenChallenge = modifiedData["force_open_challenge"];

        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);
        $(".app").html(html);

        if (isForcedOpenChallenge) {
            this.onForceOppenChallenge();
        }

        this.incident.init();
        this.feedback.init(modifiedData);
        this.recap.init();

        this.feedback.currentRoomId = this.roomId;
        this.incident.currentRoomId = this.roomId;
    }

    setGameState() {
        const elms = this.elms;
        const roomId = this.roomId;
        const roomAnswers = getFinalTeamAnswers(roomId);
        const thisRoomStatus = getRoomStatus(roomId);
        let isMiddleState = false;

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        //reset answer state
        $(elms.booleanAnswer).removeClass("is-active");
        this.toggleCheckButton();

        const setSelectedAnswers = (answers) => {
            $.each(answers, (questionID, objAnswer) => {
                const answerValue = objAnswer?.answer || objAnswer;

                isMiddleState =
                    objAnswer?.isMiddleState && !isMiddleState
                        ? true
                        : isMiddleState;

                const $question = $(
                    elms.booleanItem + `[data-id="${String(questionID)}"]`,
                );

                $question
                    .find(elms.booleanAnswer)
                    .removeClass("is-active")
                    .prop("checked", false);

                $question
                    .find(elms.booleanAnswer + `[data-id="${answerValue}"]`)
                    .addClass("is-active")
                    .prop("checked", true);

                this.feedback.setFeedback(questionID, answerValue, this._data);
            });
        };

        if (roomAnswers && Object.keys(roomAnswers).length) {
            this.incident.populateIncidents(roomAnswers, this._data);

            setSelectedAnswers(roomAnswers);
        } else {
            //get individual answers from local storage
            const individualAnswers = getTeamAnswers(roomId);
            if (Object.keys(individualAnswers).length) {
                setSelectedAnswers(individualAnswers);
                this.toggleCheckButton();
            }
        }

        if (thisRoomStatus === "is-status-completed") {
            if (!this.meSubmittingAnswer)
                $(elms.check).removeClass("is-checked");

            $(elms.questionPopup).addClass("is-completed");
            $(".app__page").addClass("is-room-completed");
            $(".js-challenge-coordinate").addClass("is-finished is-disabled");

            this.incident.populateIncidents(roomAnswers, this._data);
        }

        // getRoomAnswers(roomId).then((data) => {
        //     this.updateUserChoicesList(data);
        // });

        if ($(window).width() / $(window).height() === 1.6) {
            this.hotspotSize += 2.5;
            $(".js-challenge-coordinate")[0].style["top"] = "52.4%";
            $(".js-challenge-coordinate")[0].style["left"] = "35.8%";
        }

        gsap.registerPlugin(Draggable);
    }

    // ============================== CUSTOM FUNCTION
    onBackgroundScroll(e) {
        let delta = e.originalEvent.deltaY < 0 ? "up" : "down";
        let baseSize = $(this.elms.background)
            .css("font-size")
            .replace("px", "");
        let intBaseSize = parseFloat(baseSize);
        const hasHint = $(".hint__popup").length;

        if (hasHint) {
            const isHintHovered = $(".hint__popup").is(":hover");

            if (isHintHovered) return;
        }

        if (delta === "up" && this.zoom < 120) {
            this.zoom += 2;
            this.hotspotSize += 0.55;
        } else if (delta === "down" && this.zoom > 100) {
            this.zoom -= 2;
            this.hotspotSize -= 0.55;
        }
        $(this.elms.background).css({
            width: `${this.zoom}%`,
            height: `${this.zoom}%`,
            transform: `translate(-50%, -50%)`,
        });
        $(".screen__navigate").css({
            width: `${this.zoom}%`,
            height: `${this.zoom}%`,
            transform: `translate(-50%, -50%)`,
        });
        $(".js-screen-hotspot").css({
            fontSize: intBaseSize * (this.zoom / 100),
        });
        this.startX = 0;
        this.startY = 0;
        gsap.set(".js-draggable", { clearProps: "transform" });
    }

    /**
     * Decide whether to disabled or enabled boolean action (Check btn)
     * @returns {Boolean}
     */
    toggleCheckButton() {
        const elms = this.elms;
        let isAnsweredAll = true;

        $(elms.booleanItem).each(function () {
            const selected = `${elms.booleanAnswer}.is-active`;
            const isThisAnswered = $(this).find(selected).length > 0;
            if (!isThisAnswered) return (isAnsweredAll = false);
        });

        $(elms.checkBtn).prop("disabled", !isAnsweredAll);
        return isAnsweredAll;
    }

    getSavedAnswers() {
        const roomID = this.roomId;
        const states = Storage.get("states", {});
        const savedAnswers = states?.answers?.[roomID] || {};

        return savedAnswers;
    }

    setSavedAnswers(answers) {
        const roomID = this.roomId;
        let states = Storage.get("states", {});
        if (!states?.answers) states.answers = {};
        if (!states?.answers?.[roomID]) states.answers[roomID] = {};
        states.answers[roomID] = answers;

        return Storage.set("states", states);
    }

    /**
     * Save answer for particular questionId into local storage
     * @param {string} questionId
     * @param {string} value
     */
    saveAnswer(questionId, value) {
        let savedAnswers = this.getSavedAnswers();
        savedAnswers[questionId] = value;
        this.setSavedAnswers(savedAnswers);
        this.updateUserAnswer(questionId, value);
    }

    onAnswerBoolean(e, el) {
        const $this = $(el);
        const elms = this.elms;
        const $boolean = $this.parents(elms.questionPopup);

        if ($boolean.hasClass("is-completed")) {
            return false;
        }

        //save the answer into local storage
        const questionID = $this.parents(elms.booleanItem).attr("data-id");
        const theAnswer = $this.attr("data-id");
        this.saveAnswer(questionID, theAnswer);

        const inputParent = $this.parents(elms.answers);
        inputParent
            .find(elms.booleanAnswer)
            .removeClass("is-active")
            .prop("checked", false);
        $this.addClass("is-active").prop("checked", true);
        this.toggleCheckButton();
    }

    onCheck(e, el) {
        const self = this;
        const elms = this.elms;
        const $el = $(el);

        if ($el.hasClass("is-loading") || $el.hasClass("is-completed")) return;

        $el.parent().removeClass("is-checked");
        $el.addClass("is-loading").prop("disabled", true);

        const roomID = this.roomId;
        let roomStatus = "is-status-started";
        // let roomAnswers = getRoomAnswerById(roomID);
        let playerAnswers = {};
        let correct_count = 0;
        let middle_count = 0;
        let wrong_count = 0;

        const data = this._data;
        const incident = this.incident;

        $(elms.booleanItem).each(function () {
            const $item = $(this);
            const $answer = $item.find(elms.booleanAnswer + ".is-active");
            const qId = $item.attr("data-id");
            const answer = $answer.attr("data-id");

            const questionData = data.questions.find(
                (q) => q.question_id === qId,
            );
            const answerData = questionData.answers.find(
                (a) => a.answer_id === answer,
            );
            const isGotIncident = incident.isGotIncident(
                answerData.incident.incident_percentage,
            );
            const feedback = answerData.feedback;

            if (feedback && feedback.action_cost) {
                self.feedback.saveActionCost(feedback.action_cost);
            }

            playerAnswers[qId] = {
                answer: answer,
                isGotIncident: isGotIncident,
                incidentPercentage: answerData.incident.incident_percentage,
                isMiddleState: false,
            };
        });

        this.incident.populateIncidents(playerAnswers, this._data);

        // const savedAnswers = this.getSavedAnswers();

        roomStatus = "is-status-completed";
        this.meSubmittingAnswer = true;

        const onSuccess = () => {
            $el.parent().addClass("is-completed");
            $el.parents(elms.questionPopup).addClass("is-completed");
        };

        saveFinalRoomAnswers(roomID, playerAnswers)
            .then(onSuccess)
            .catch(() => (this.meSubmittingAnswer = false));

        $el.parent().addClass("is-checked");

        $(".js-challenge-coordinate").addClass("is-finished is-disabled");
        $(elms.correct).find(".count").text(correct_count);
        $(elms.middle).find(".count").text(middle_count);
        $(elms.wrong).find(".count").text(wrong_count);

        $el.removeClass("is-loading").removeAttr("disabled");

        this.onQuestionToggler(true);

        maybeUpdateRoomStatus(roomID, roomStatus);
    }

    getTimeRisk(roomAnswers, playerAnswer) {
        if (!roomAnswers || !playerAnswer) return null;

        for (var key in roomAnswers) {
            if (Array.isArray(roomAnswers[key])) {
                var found = $.grep(roomAnswers[key], function (item) {
                    return item.answer_id === playerAnswer;
                });

                if (found.length > 0) {
                    return found[0].incident.time_risk;
                }
            }
        }
        return null; // not found
    }

    onQuestionToggler(skipAudio = false) {
        const elms = this.elms;
        const hasOpen = $(elms.questionPopup).hasClass("is-open");
        const isOpened = !hasOpen;
        const blur = $(".app-blur");

        blur.toggleClass("is-blurred", isOpened);

        $(elms.questionPopup).toggleClass("is-open", isOpened);

        if (skipAudio) return;
        const ringtoneEl = this.getMediaElement(elms.ringtone);
        ringtoneEl && ringtoneEl.play();
    }

    playChallengeAudio() {
        const elms = this.elms;
        $(elms.callPlayer).addClass("audio-playing");
        const ringtoneEl = this.getMediaElement(elms.ringtone);
        const challengeEl = this.getMediaElement(elms.challengeAudio);
        ringtoneEl && ringtoneEl.pause();
        challengeEl && challengeEl.play();

        challengeEl.addEventListener("ended", () => {
            $(elms.callPlayer)
                .removeClass("audio-playing")
                .addClass("audio-stop");
        });

        if (challengeEl.textTracks.length > 0) {
            const subtitle = challengeEl.textTracks[0];
            subtitle.mode = "hidden";

            subtitle.addEventListener("cuechange", () => {
                const activeCues = subtitle.activeCues;
                const $captionDisplay = $(".caption-display");

                if (activeCues.length > 0) {
                    // @ts-ignore
                    const activeCue = activeCues[0].text;
                    $captionDisplay.show();
                    $captionDisplay.text(activeCue);
                } else {
                    $captionDisplay.text("");
                    $captionDisplay.hide();
                }
            });
        } else {
            $(".caption-display").hide();
        }
    }

    skipAudio() {
        const elms = this.elms;
        const challengeEl = this.getMediaElement(elms.challengeAudio);
        challengeEl && challengeEl.pause();
        $(elms.callPlayer).removeClass("audio-playing");
        $(elms.callPlayer).addClass("audio-stop");
        $(".caption-display").hide();
    }

    proceedToQuestion() {
        const elms = this.elms;

        $(elms.audioBox).addClass("is-closed");
        $(elms.questionBox).addClass("is-open");
    }

    /**
     * Safely get an HTMLMediaElement from a selector
     * @param {string} selector
     * @returns {HTMLMediaElement|null}
     */
    getMediaElement(selector) {
        const el = $(selector).get(0);
        return el instanceof HTMLMediaElement ? el : null;
    }

    onForceOppenChallenge() {
        const closeButton = this.elms.closeButtonPopup;
        const backButton = this.elms.backButton;

        const blur = $(".app-blur");

        blur.addClass("is-blurred");

        $(closeButton).addClass("hidden");
        $(backButton).addClass("up-front");
    }

    updateUserAnswer(questionId, answer) {
        const roomId = this.roomId;

        updateRoomAnswer(roomId, {
            [questionId]: answer,
        });
    }

    updateUserChoicesList(answer) {
        if ($("#locationInfo-item").length < 1) return;

        const fbRoomAnswers = answer.val() ?? {};
        const players = getState().gameProgress.players;
        const template = $("#locationInfo-item").html();

        // Filter the player to not include the current user
        const onlinePlayers = players.filter(
            (player) => player.isOnline && player.userId !== CONFIG.user.id,
        );

        $(".userChoice_list").each(function () {
            const $context = $(this).parents(".js-userChoices-context");
            const hasContext = $context.length > 0;

            const questionID = hasContext
                ? $context.attr("data-question-id")
                : undefined;
            const questionAnswerID = hasContext
                ? $context.attr("data-answer-id")
                : undefined;

            const users = onlinePlayers.filter((player) => {
                const usrID = player.userId;
                const thisPlayerAnswer = fbRoomAnswers[usrID]?.choice;

                if (typeof thisPlayerAnswer !== "object") {
                    return;
                }

                if (thisPlayerAnswer[questionID] == questionAnswerID) {
                    return player;
                }
            });

            const html = compile(template, { players: users });
            $(this).html(html);
        });
    }

    replayAudio() {
        [
            this.getMediaElement(this.elms.ringtone),
            this.getMediaElement(this.elms.challengeAudio),
        ].forEach((el) => el && (el.currentTime = 0));

        this.playChallengeAudio();
    }

    finishFeedback() {
        this.feedback.hide();
    }

    finishRecap() {
        this.recap.hide();

        setTimeout(() => {
            const mainroomId = this._data.mainroom_id;
            GameLogic.goToPage(mainroomId);
        }, 1500);
    }
}
